// src/components/Layout.jsx
import React from "react";
import styled from "styled-components";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";

/**
 * Wraps every public page. `padTop` adds room for the fixed navbar —
 * pass false on the homepage so the hero can sit under the transparent bar.
 */
export default function Layout({ children, padTop = true }) {
  return (
    <>
      <Navbar />
      <Main $padTop={padTop}>{children}</Main>
      <Footer />
      <CartDrawer />
    </>
  );
}

const Main = styled.main`
  min-height: 60vh;
  padding-top: ${({ $padTop, theme }) =>
    $padTop ? theme.layout.navHeight : "0"};
`;
